import get from 'lodash/get';
import constants from './constants';
import items from './items';
import itemsMap from './items-map';
export function createItem({
  ariaLabel = '',
  icon = '',
  id = null,
  label = '',
  path = '#',
  pathType = constants.PATH_TYPE.relative,
  submenu = [],
  target = '_self',
  iamPermissions,
  selected
}) {
  return {
    ariaLabel,
    icon,
    id,
    label,
    path,
    pathType,
    submenu,
    target,
    iamPermissions,
    selected
  };
}

function createAccountOption(account) {
  return {
    label: get(account, 'name', ''),
    value: get(account, '_id', ''),
    isCurrent: get(account, 'isCurrent', false),
    enterpriseMarketplace: {
      enabled: get(account, 'enterpriseMarketplace.enabled', false)
    }
  };
}

export function createAccountMap(accounts = []) {
  return accounts.reduce((acc, account) => {
    const hasIdProp = Object.prototype.hasOwnProperty.call(account, '_id');

    if (hasIdProp) {
      acc[account['_id']] = account;
    }

    return acc;
  }, {});
}
export function parseUserData(userData) {
  const user = get(userData, 'OMUser', {});
  const accounts = get(userData, 'OMAccounts', []);
  const currentAccount = accounts.find(account => account.isCurrent);
  const accountOptions = accounts.map(createAccountOption);
  const accountMap = createAccountMap(accounts);
  return {
    accountMap,
    accountOptions,
    currentAccount: createAccountOption(currentAccount),
    currentAccountId: get(currentAccount, '_id', ''),
    emailAddress: get(user, 'emailAddress', ''),
    firstName: get(user, 'firstName', ''),
    id: get(user, '_id', ''),
    lastName: get(user, 'lastName', '')
  };
}
export function getUsersValidSectionPages(sectionObject = {}) {
  const {
    sectionName = '',
    sectionItems = []
  } = sectionObject;
  return (user = {}) => {
    const account = get(user, ['accountMap', [user.currentAccountId]], {});
    const validNavSectionPages = get(account, 'validNavSectionPages', []);
    if (validNavSectionPages.length === 0) return [];
    const allowedPageIDs = get(validNavSectionPages, sectionName, []).map(page => get(page, 'sectionKey', ''));
    return sectionItems.filter(({
      id
    }) => allowedPageIDs.includes(id));
  };
}
export function getWorkspacePages(user = {}) {
  return getUsersValidSectionPages({
    sectionName: constants.NAV_SECTIONS.workspace,
    sectionItems: items.workspaceItems
  })(user);
}
export function getAccountSwitchNavSection(parsedUser) {
  let accountOptions = [];

  if (parsedUser) {
    accountOptions = get(parsedUser, 'accountOptions', []);
    accountOptions = accountOptions.map((account, i) => {
      return { ...account,
        ariaLabel: `Account Option ${i}`,
        id: account.value,
        submenu: [],
        isCurrentAccount: account.isCurrent
      };
    });
  }

  const accountMenuItem = {
    ariaLabel: 'Account menu link',
    id: 'account-switcher',
    label: 'Account',
    submenu: accountOptions
  };
  return accountMenuItem;
}
export function getPartnerPages(user = {}) {
  return getUsersValidSectionPages({
    sectionName: constants.NAV_SECTIONS.partner,
    sectionItems: items.partnerSidenavItems
  })(user);
}
export default { ...constants,
  createItem,
  navItems: items,
  navItemsMap: itemsMap,
  parseUserData,
  getWorkspacePages,
  getPartnerPages,
  getUsersValidSectionPages,
  getAccountSwitchNavSection
};